import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-identificacao-cnpj',
  templateUrl: './identificacao-cnpj.component.html',
  styleUrls: ['./identificacao-cnpj.component.scss']
})
export class IdentificacaoCnpjComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    let secundaria =  this.consulta.atv_econ_secundaria || this.consulta.atividadeEconomicaSecundaria || this.consulta.atividade_economica_secundaria || [];

    this.consulta.atividadeEconomicaSecundaria = secundaria.registros || secundaria;
  
  }

}
